<div class="bg-white flex flex-col gap-4 p-4 border border-gray-200 rounded-lg">
  <!-- Section: GRUNDEINSTELLUNGEN -->
  <div class="flex flex-col gap-1 pt-2 pb-1">
    <span class="text-[11px] font-medium text-gray-400 uppercase">Grundeinstellungen</span>
    <div class="border-b border-gray-200"></div>
  </div>

  <!-- Name (Pflichtfeld) -->
  <div class="flex flex-col gap-1">
    <bic-input (valueChange)="stateChange.emit({ name: $event })"
               [label]="'Name *'"
               [placeholder]="'z. B. ASR-Prüfung Bürogebäude'"
               [value]="state.name" [showX]="false">
    </bic-input>
    @if (showErrors && !state.name.trim()) {
      <span class="text-xs text-red-600">Name ist ein Pflichtfeld.</span>
    }
  </div>

  <!-- Beschreibung -->
  <div class="flex flex-col gap-1">
    <div class="flex items-center justify-between">
      <label class="text-sm font-medium text-gray-900">Beschreibung</label>
      @if (previousDescription === null) {
        <button
          (click)="optimizeDescription()"
          [disabled]="optimizingDescription || !state.description?.trim()"
          class="flex items-center gap-1 text-xs text-green hover:underline disabled:opacity-50 disabled:cursor-not-allowed"
          type="button">
          <fa-icon [class.animate-spin]="optimizingDescription"
                   [icon]="optimizingDescription ? faSpinner : faSparkles" class="text-xs"></fa-icon>
          {{ optimizingDescription ? 'Verbessere…' : 'Mit chatBIC verbessern' }}
        </button>
      } @else {
        <button
          (click)="restoreDescription()"
          class="text-xs text-gray-500 hover:underline"
          type="button">
          Wiederherstellen
        </button>
      }
    </div>
    <bic-textarea
      [value]="state.description"
      (valueChange)="stateChange.emit({ description: $event })"
      placeholder="Was soll geprüft werden? Wird in der Übersicht angezeigt und dient chatBIC als Grundlage für den Check."
      [rows]="6">
    </bic-textarea>
    <p class="text-xs text-gray-500 leading-normal">chatBIC kann Fehler machen. Überprüfe wichtige Informationen.</p>
  </div>

  <!-- Section: TRIGGER -->
  <div class="flex flex-col gap-1 pt-2 pb-1">
    <span class="text-[11px] font-medium text-gray-400 uppercase">Trigger</span>
    <div class="border-b border-gray-200"></div>
  </div>

  <!-- Trigger content -->
  <div class="flex flex-col gap-5">
    <span class="text-sm font-medium text-gray-900">Wann startet der Check?*</span>
    <div class="grid grid-cols-4 gap-4">
      @for (trigger of triggerOptions; track trigger.mode) {
        <!-- Gesperrte Kacheln sind nicht [disabled]: ein deaktivierter Button bekommt keine
             Maus-Ereignisse, der Tooltip mit dem Grund bliebe unsichtbar. -->
        <button
          (click)="onTriggerClick(trigger.mode)"
          [attr.aria-disabled]="!isTriggerEnabled(trigger.mode)"
          [class]="triggerClass(trigger.mode)"
          [tooltip]="$any(triggerTooltip(trigger.mode))"
          class="flex flex-1 items-center gap-4 px-4 py-2 rounded-lg border transition-colors text-left"
          type="button">
          <div class="flex items-center justify-center w-6 h-6 shrink-0">
            <fa-icon
              [icon]="trigger.icon"
              [class]="state.triggerMode === trigger.mode || (trigger.mode === 'schedule' && scheduleSummary) ? 'text-gray-500' : 'text-gray-300'"
              class="text-base"></fa-icon>
          </div>
          <div class="flex flex-col min-w-0">
            <span class="text-sm font-medium text-gray-900 leading-normal">{{ trigger.label }}</span>
            <span class="text-xs font-normal text-gray-900 leading-normal">{{ trigger.description }}</span>
          </div>
        </button>
      }
    </div>

    <!-- Info hint for manual trigger -->
    @if (state.triggerMode === 'manual') {
      <div class="flex items-center gap-2 h-[38px] px-3 py-2 bg-gray-100 rounded-lg">
        <fa-icon [icon]="faCircleInfo" class="text-gray-500 text-xs shrink-0"></fa-icon>
        <span class="text-sm font-medium text-gray-500 whitespace-nowrap">Keine weitere Konfiguration nötig. Der Check wird über „Ausführen" in der myCheck-Übersicht gestartet.</span>
      </div>
    }
    @if (scheduleSummary) {
      <div class="flex items-center gap-2 min-h-[38px] px-3 py-2 bg-gray-100 rounded-lg">
        <fa-icon [icon]="faCircleInfo" class="text-gray-500 text-xs shrink-0"></fa-icon>
        <span class="text-sm font-medium text-gray-500 min-w-0">Zeitplan: {{ scheduleSummary }}</span>
        @if (scheduleUnavailableReason === null) {
          <button (click)="openSchedule.emit()" class="text-sm font-medium text-green hover:underline shrink-0"
                  type="button">Bearbeiten</button>
        }
      </div>
    }
  </div>
</div>
